module.exports = {
  StartEndDateCannotEmpty: 'วันที่เริ่มต้นหรือวันที่สิ้นสุดไม่สามารถเว้นว่างได้!',
  StartBeEarlierThanDate: 'วันที่เริ่มต้นต้องน้อยกว่าวันที่สิ้นสุด!',
  Continent: 'ทวีป',
  Route: 'เส้นทางเดินเรือ',
  Network: 'เครือข่าย',
  Currency: 'สกุลเงิน',
  ContainerType: 'ประเภทตู้คอนเทนเนอร์',
  Package: 'บรรจุภัณฑ์',
  BillOfLadingType: 'ประเภทใบตราส่งสินค้า',
  CargoType: 'ประเภทสินค้า',
  TradeTerms: 'เงื่อนไขการค้า',
  TransportationTerms: 'เงื่อนไขการขนส่ง',
  FreightTerms: 'เงื่อนไขค่าขนส่ง',
  TradeMethod: 'วิธีการค้า',
  CustomsDeclarationMethod: 'วิธีการสำแดงศุลกากร',
  AirFreightServiceItem: 'รายการบริการค่าขนส่งทางอากาศ',
  RelatedPort: 'ท่าเรือที่เกี่ยวข้อง',
  AirWaybillSundryCharge: 'ค่าบริการเพิ่มเติมในใบตราส่งทางอากาศ',
  ClientType: 'ประเภทลูกค้า',
  AppraisalCategory: 'ประเภทการประเมิน',
  ShippingDocumentMethod: 'วิธีการออกใบตราส่ง',
  CustomBusinessType: 'ประเภทธุรกิจที่กำหนดเอง',
  TransitDocumentType: 'ประเภทเอกสารหมุนเวียน',
  CommissionRule: 'กฎเกณฑ์ค่าคอมมิชชัน',
  RailwayLine: 'เส้นทางรถไฟ',
  ValueAddedService: 'บริการเพิ่มมูลค่า',
  BilledUnitUnit: 'หน่วยคิดเงิน/หน่วย',
  HazardousGoods: 'วัตถุอันตราย',
  CargoInformation: 'ข้อมูลสินค้า',
  LiabilityReason: 'สาเหตุการตัดสินความรับผิดชอบ',
  ClientSource: 'แหล่งที่มาของลูกค้า',
  MultimodalTransportType: 'ประเภทการขนส่งแบบผสม',
  VehicleType: 'รุ่นรถ',
  CustomEqType: 'ประเภทตู้ที่กำหนดเอง',
  CollaborativeBusinessType: 'ประเภทธุรกิจแบบร่วมมือ',
  Records: 'รายการ;',
  recordsImportedToTheSystem: '@records นำเข้าสู่ระบบสำเร็จ!',
  Records2: 'รายการ',
  Edit: 'แก้ไข',
  Delete: 'ลบ',
  Disable: 'ระงับการใช้งาน',
  Enable: 'เปิดใช้งาน',
  AreWantToDeleteRecord: 'คุณแน่ใจหรือไม่ที่จะลบรายการนี้?',
  Reminder: 'แจ้งเตือน',
  Confirm: 'ยืนยัน',
  Cancel: 'ยกเลิก',
  SuccessfullyDeleted: 'ลบสำเร็จ!',
  DeletionCanceled: 'ยกเลิกการลบแล้ว',
  DoToOverwriteExistingData: 'ต้องการทับข้อมูลที่มีอยู่หรือไม่',
  Overwrite: 'ทับ',
  PleaseSelectDataToExport: 'กรุณาเลือกข้อมูลที่ต้องการส่งออก',
  UploadedBeXlsOrFormat: 'อัปโหลดได้เฉพาะไฟล์รูปแบบ xls และ xlsx เท่านั้น!',
  FileSizeCannotExceed2MB: 'ขนาดไฟล์ต้องไม่เกิน 2MB',
  ImportPleaseContactTheAdministrator: 'นำเข้าไม่สำเร็จ กรุณาติดต่อผู้ดูแลระบบ',
  DataExistingDataInTable: 'ข้อมูลซ้ำกับที่มีอยู่ในตารางแล้ว!',
  SuccessfullyAdded: 'เพิ่มข้อมูลสำเร็จ',
  City: 'เมือง',
  BusinessType: 'ประเภทธุรกิจ',
  PlatformCustomerService: 'บริการลูกค้าของแพลตฟอร์ม',
  Code: 'รหัส',
  Name: 'ชื่อ',
  ChineseName: 'ชื่อภาษาจีน',
  EnglishName: 'ชื่อภาษาอังกฤษ',
  ChineseName2: 'ชื่อภาษาจีน',
  FeeDetailsXls: 'รายละเอียดค่าใช้จ่าย.xls',
  UnitedNationsNumberAlreadyExists: 'หมายเลข UN มีอยู่แล้ว',
  UserCannotBeEmpty: 'ผู้ใช้ไม่สามารถเว้นว่างได้',
  Yes: 'ใช่',
  No: 'ไม่',
  MergeInProgressPleaseWait: 'กำลังรวมข้อมูล กรุณารอสักครู่',
  YouExpectedToCompleteLater: 'คุณสามารถออกจากหน้านี้ได้ การรวมข้อมูลจะเสร็จสิ้นภายใน 10 นาที กรุณาตรวจสอบภายหลัง',
  Note: 'แจ้งเตือน',
  Success: 'ดำเนินการสำเร็จ',
  ChineseNameCannotBeEmpty: 'ชื่อภาษาจีนไม่สามารถเว้นว่างได้',
  EmailFormatError: 'รูปแบบอีเมลไม่ถูกต้อง',
  ApplicableOrderRulescombinedName: 'ชื่อกฎการปล่อยเอกสาร (แบบผสม) ที่ใช้ได้',
  OnlyCanBeSetPort: 'สามารถตั้งค่าตัวแทนจัดส่งเริ่มต้นได้เพียงหนึ่งรายการต่อท่าเรือปลายทางเดียวกัน',
  UserCannotBeEmpty2: 'ผู้ใช้ไม่สามารถเว้นว่างได้!',
  DataIsIncorrectPleaseCheck: 'ข้อมูลไม่ถูกต้อง กรุณาตรวจสอบ!',
  PleaseNumberYouWantDelete: 'กรุณาเลือกหมายเลขสัญญาที่ต้องการลบ!',
  PleaseSelectABranch: 'กรุณาเลือกสาขา!',
  SiteNotSelected: 'ยังไม่ได้เลือกสถานี',
  AlreadyAddedCannotAddRepeatedly: 'เพิ่มแล้ว ไม่สามารถเพิ่มซ้ำได้!',
  AddedSuccessfully: 'เพิ่มข้อมูลสำเร็จ',
  SavedLibraryAlreadyExistsSave: 'บันทึกสำเร็จ คำไวพจน์ต่อไปนี้มีอยู่ในคลังแล้ว ไม่จำเป็นต้องบันทึก:',
  SavedWordsHaveBeenTimes: 'บันทึกสำเร็จ คำไวพจน์ต่อไปนี้ถูกป้อนหลายครั้ง:',
  TheHaveBeenEnteredTimes: 'คำไวพจน์ต่อไปนี้ถูกป้อนหลายครั้ง:',
  FieldName: 'ชื่อฟิลด์',
  SensitiveWords: 'คำไวพจน์',
  Threshold: 'ค่าระดับความไวพจน์',
  ThresholdTip: 'ค่าระดับความไวพจน์แสดงจำนวนหลักที่คลุมเครือของคำไวพจน์ 0 หมายถึงการตรวจสอบที่ตรงกัน 100%',
  EditedSuccessfully: 'แก้ไขสำเร็จ',
  ChineseProductName: 'ชื่อสินค้าภาษาจีน',
  EnglishProductName: 'ชื่อสินค้าภาษาอังกฤษ',
  ShippingMarks: 'เครื่องหมาย',
  EmailRemindertestOnly: 'แจ้งเตือนทางอีเมล (สำหรับการทดสอบ)',
  SplitDataBecomesNewData: 'แยก (ข้อมูลเก่ากลายเป็นข้อมูลใหม่)',
  SplittingDataAreYouSplit: 'หลังแยกข้อมูลเดิมจะถูกนำออก ยืนยันการแยก?',
  SplitSuccessfullySplitInto: 'แยกสำเร็จ แยกออกเป็น',
  SensitiveWordManagement: 'การจัดการคำไวพจน์',
  CodeCannotBeEmpty: 'รหัสไม่สามารถเว้นว่างได้',
  EnglishNameCannotBeEmpty: 'ชื่อภาษาอังกฤษไม่สามารถเว้นว่างได้',
  ContractConfiguration: 'การตั้งค่าสัญญา',
  NoteTheReminderMethodIs: 'หมายเหตุ: วิธีการแจ้งเตือนคือ',
  ReminderConfiguration: 'การตั้งค่าแจ้งเตือน:',
  ReminderRemaining: 'เหลือเวลาจนถึงวันหมดอายุ',
  DaysBeforeTheDueDate: 'วันแจ้งเตือน',
  ReminderUser: 'แจ้งเตือนผู้ใช้:',
  ContractAdministrator: 'ผู้ดูแลสัญญา',
  Sales: 'ฝ่ายขาย',
  ProhibitionOfCreatingBusinessConfiguration: 'ห้ามสร้างการตั้งค่าธุรกิจ:',
  ContractAbleToCreateExpiration: 'หลังสัญญาหมดอายุจะไม่สามารถสร้างธุรกิจได้อีก',
  SavedSuccessfully: 'บันทึกสำเร็จ',
  CustomerLevel: 'ระดับลูกค้า',
  ContractStatus: 'สถานะสัญญา',
  ContractType: 'ประเภทสัญญา',
  ExtensionCycle: 'ระยะเวลาขยาย',
  Partner: 'พันธมิตร',
  ContractNumber: 'เลขที่สัญญา',
  EffectiveDate: 'วันที่มีผล',
  ExpirationDate: 'วันที่หมดอายุ',
  ContractAgreement: 'ข้อตกลงสัญญา',
  CustomerContract: 'สัญญาลูกค้า',
  SupplierContract: 'สัญญาผู้จัดหา',
  OverseasAgentContract: 'สัญญาตัวแทนต่างประเทศ',
  OtherContracts: 'สัญญาอื่นๆ',
  ContractTerms: 'เงื่อนไขสัญญา',
  DeferredAfterExpiration: 'ขยายอายุต่อหลังหมดอายุ',
  N1Year: '1 ปี',
  N2Years: '2 ปี',
  N3Years: '3 ปี',
  Other: 'อื่นๆ',
  OneClickRenewal: 'ต่ออายุอัตโนมัติ',
  Close: 'ปิด',
  AddContract: 'เพิ่มสัญญา',
  EditContract: 'แก้ไขสัญญา',
  RenewContract: 'ต่ออายุสัญญา',
  ViewContract: 'ดูสัญญา',
  Contract: 'สัญญา',
  PartnerCannotBeEmpty: 'พันธมิตรไม่สามารถเว้นว่างได้',
  ContractNumberCannotBeEmpty: 'เลขที่สัญญาไม่สามารถเว้นว่างได้',
  EffectiveDateCannotBeEmpty: 'วันที่มีผลไม่สามารถเว้นว่างได้',
  ExpirationDateCannotBeEmpty: 'วันที่หมดอายุไม่สามารถเว้นว่างได้',
  ContractAgreementCannotBeEmpty: 'ข้อตกลงสัญญาไม่สามารถเว้นว่างได้',
  unSupportContractCurrency: 'ไม่พบอัตราแลกเปลี่ยนโดยตรงหรือโดยอ้อมระหว่าง "{0}" และ "{1}" โปรดบำรุงรักษาอัตราแลกเปลี่ยนที่เกี่ยวข้องทันเวลา',
  QuickSearchContractNumber: 'ค้นหาด่วน: เลขที่สัญญา',
  LogRecord: 'บันทึกประวัติ',
  Add: 'เพิ่ม',
  HintSetToExpireDays: 'คำเตือน: ระบบจะตั้งค่าเป็นใกล้หมดอายุภายใน 30 วัน',
  OperationType: 'ประเภทการดำเนินการ',
  Operator: 'ผู้ดำเนินการ',
  Time: 'เวลา',
  EditField: 'แก้ไขฟิลด์',
  OriginalValue: 'ค่าดั้งเดิม',
  NewValue: 'ค่าใหม่',
  AuditStatus: 'สถานะการตรวจสอบ',
  OperationDate: 'วันที่ดำเนินการ',
  SettlementType: 'ประเภทการชำระเงิน',
  SettlementMethod: 'วิธีการชำระเงิน',
  Limit: 'วงเงิน',
  LimitCurrency: 'สกุลเงินวงเงิน',
  DateType: 'ประเภทวันที่',
  BillingCycle: 'รอบระยะเวลาบัญชี',
  WhetherToPostpone: 'เลื่อนหรือไม่',
  PostponementCycle: 'รอบระยะเวลาการเลื่อน',
  WhetherChapterHasBeenUploaded: 'อัปโหลดตราประทับการจองแล้วหรือไม่',
  WhetherAgreementHasBeenUploaded: 'อัปโหลดสัญญาแล้วหรือไม่',
  Operation: 'ดำเนินการ',
  Renewal: 'ต่ออายุ',
  Revoke: 'ยกเลิก',
  TheAndTheOperationAllowed: 'สัญญานี้ได้รับการต่ออายุแล้ว ห้ามดำเนินการ',
  DoYouNeedToUpdate: 'จำเป็นต้องอัปเดตหรือไม่',
  ContractCreator: 'ผู้สร้างสัญญา',
  ContractCreationTime: 'เวลาที่สร้างสัญญา',
  PartnerCreator: 'ผู้สร้างพันธมิตร',
  ContractAuditor: 'ผู้ตรวจสอบสัญญา',
  ContractAuditTime: 'เวลาตรวจสอบสัญญา',
  PleaseSelectContractRecord: 'กรุณาเลือกบันทึกสัญญา',
  ContractRecordIsEmpty: 'ไม่มีบันทึกสัญญา',
  ContractRevocationSuccessful: 'ยกเลิกสัญญาสำเร็จ',
  QuickSearch: 'ค้นหาด่วน:',
  BulkRejection: 'ปฏิเสธเป็นกลุ่ม',
  All: 'ทั้งหมด',
  Unaudited: 'ยังไม่ตรวจสอบ',
  Submitted: 'ส่งแล้ว',
  Audited: 'ตรวจสอบแล้ว',
  PleaseSelectData: 'กรุณาเลือกข้อมูล',
  OnlySchemesWithAuditUnreviewed: 'สามารถเลือกเฉพาะแผนค่าใช้จ่ายที่สถานะการตรวจสอบยังไม่ส่งเท่านั้น',
  OnlySchemesWithAuditReviewed: 'สามารถเลือกเฉพาะแผนค่าใช้จ่ายที่สถานะการตรวจสอบแล้วเท่านั้น',
  OnlySchemesWithAuditSubmitted: 'สามารถเลือกเฉพาะแผนค่าใช้จ่ายที่สถานะการตรวจสอบส่งแล้วเท่านั้น',
  OnlyGuaranteeWithAuditUnreviewed: 'สามารถเลือกเฉพาะหนังสือค้ำประกันที่สถานะการตรวจสอบยังไม่ส่งเท่านั้น',
  OnlyGuaranteeWithAuditReviewed: 'สามารถเลือกเฉพาะหนังสือค้ำประกันที่สถานะการตรวจสอบแล้วเท่านั้น',
  OnlyGuaranteeWithAuditSubmitted: 'สามารถเลือกเฉพาะหนังสือค้ำประกันที่สถานะการตรวจสอบส่งแล้วเท่านั้น',
  GuaranteeFileIsNull: 'ไม่มีไฟล์หนังสือค้ำประกัน',
  SelectGuaranteeFileIsNull: '{0} ไม่ได้อัปโหลดไฟล์หนังสือค้ำประกัน',
  CodeDuplicatedPleaseReEnter: 'รหัสซ้ำ กรุณากรอกใหม่',
  Country: 'ประเทศ',
  CannotEditMultipleSchemes: 'ไม่สามารถแก้ไขหลายแผนได้',
  CannotCopyMultipleSchemes: 'ไม่สามารถคัดลอกหลายแผนได้',
  DeletedSuccessfully: 'ลบสำเร็จ',
  PleaseEnterTheSchemeName: 'กรุณาใส่ชื่อแผนงาน',
  PleaseEnterTheStartingRow: 'กรุณาใส่หมายเลขแถวเริ่มต้น',
  PleaseTheExcelCellName: 'กรุณากรอกชื่อเซลล์ Excel',
  PleaseEnterTheSpaceProportion: 'กรุณาใส่อัตราส่วนของช่องว่าง',
  EnglishName2: 'ชื่อภาษาอังกฤษ',
  UnknownType: 'ประเภทไม่ทราบ',
  SeaExport: 'ส่งออกทางทะเล',
  AirExport: 'ส่งออกทางอากาศ',
  BusinessTypeCannotBeEmpty: 'ประเภทธุรกิจไม่สามารถเว้นว่างได้',
  OperationTypeCannotBeEmpty: 'ประเภทคำขอปฏิบัติการไม่สามารถเว้นว่างได้',
  ContentDescriptionCannotBeEmpty: 'คำอธิบายเนื้อหาไม่สามารถเว้นว่างได้',
  OverseasWarehouse: 'คลังสินค้าต่างประเทศ',
  PartnerInformationImport: 'นำเข้าข้อมูลพันธมิตร',
  PleaseSelectTemplateType: 'กรุณาเลือกประเภทเทมเพลต',
  PleaseSelectImportType: 'กรุณาเลือกประเภทการนำเข้า',
  ImportTime: 'เวลานำเข้า',
  SelectDate: 'เลือกวันที่',
  ImportResult: 'ผลการนำเข้า',
  PleaseSelect: 'กรุณาเลือก',
  ImportType: 'ประเภทการนำเข้า',
  ImportSuccessful: 'นำเข้าเสร็จสิ้น',
  DownloadTemplate: 'ดาวน์โหลดเทมเพลต',
  PartnerBasicInformation: 'ข้อมูลพื้นฐานของพันธมิตร',
  PartnerBillingHeaderInformation: 'ข้อมูลใบแจ้งหนี้ของพันธมิตร',
  Download: 'ดาวน์โหลด',
  ImportFile: 'นำเข้าไฟล์',
  SelectFile: 'เลือกไฟล์',
  ConfirmImport: 'ยืนยันการนำเข้า',
  ReminderPartnerBasicInformationFirst: 'เตือน: กรุณานำเข้าข้อมูลพื้นฐานของพันธมิตรก่อน',
  Search: 'ค้นหา',
  To: 'ถึง',
  ContinueImport: 'นำเข้าต่อไป',
  EnterPartnerInformation: 'เข้าสู่หน้าพันธมิตร',
  DownloadImportResult: 'ดาวน์โหลดผลการนำเข้า',
  ViewFile: 'ดูไฟล์',
  SerialNumber: 'หมายเลขลำดับ',
  LogFile: 'ไฟล์บันทึก',
  RemarkDescription: 'หมายเหตุ',
  AllSuccessful: 'สำเร็จทั้งหมด',
  AllFailed: 'ล้มเหลวทั้งหมด',
  PartiallySuccessfulPartiallyFailed: 'บางส่วนสำเร็จ บางส่วนล้มเหลว',
  TheOnlyBeXlsFormat: 'อัปโหลดไฟล์ได้เฉพาะรูปแบบ xls, xlsx เท่านั้น!',
  ConfirmDeletionOfTheSite: 'ยืนยันการลบสถานี?',
  TheByTheBusinessDeleted: 'สถานีต่อไปนี้ถูกใช้งานโดยธุรกิจแล้ว ห้ามลบ!',
  RailwayStation: 'สถานีรถไฟ',
  WhetherToOverwriteExistingData: 'ต้องการเขียนทับข้อมูลที่มีอยู่หรือไม่',
  PleaseDataYouWantExport: 'กรุณาเลือกข้อมูลที่ต้องการส่งออก',
  FileBeLargerThan2MB: 'ขนาดไฟล์ต้องไม่เกิน 2MB',
  Items: 'รายการ;',
  recordsImportedIntoTheSystem: 'บันทึก @records ถูกนำเข้าสู่ระบบสำเร็จ!',
  Items2: 'รายการ',
  PortOfLoadingPOL: 'ท่าเรือต้นทาง (POL)',
  PortOfDischargePOD: 'ท่าเรือปลายทาง (POD)',
  PlaceOfDelivery: 'สถานที่ส่งมอบ',
  ShippingCompany: 'บริษัทเรือ',
  DestinationPortAgent: 'ตัวแทนท่าเรือปลายทาง',
  ShippingRoute: 'เส้นทางเดินเรือ',
  DisplayRules: 'กฎการแสดงผล',
  OperationalRequirements: 'ข้อกำหนดการดำเนินงาน',
  PleaseEnterTheContent: 'กรุณากรอกข้อมูล',
  AttachmentDescription: 'คำอธิบายไฟล์แนบ',
  ViewAttachment: 'ดูไฟล์แนบ',
  WhetherToUseForMBL: 'ใช้สำหรับ MBL หรือไม่',
  WhetherToUseForHBL: 'ใช้สำหรับ HBL หรือไม่',
  AddPortRequirementsseaPort: 'เพิ่มข้อกำหนดท่าเรือ (ท่าเรือทะเล)',
  PleaseARecordForEditing: 'กรุณาเลือกรายการเพื่อแก้ไข',
  EditPortRequirementsseaPort: 'แก้ไขข้อกำหนดท่าเรือ (ท่าเรือทะเล)',
  PleaseARecordForDeletion: 'กรุณาเลือกรายการเพื่อลบ',
  WhetherDeleteTheSelectedRecords: 'ยืนยันการลบรายการที่เลือกหรือไม่',
  Notice: 'แจ้งเตือน',
  DeletionCancelled: 'ยกเลิกการลบแล้ว',
  DeletionFailed: 'ลบไม่สำเร็จ!',
  DisplayRulesAreRequired: 'ต้องกรอกกฎการแสดงผล!',
  OperationalRequirementsAreRequired: 'ต้องกรอกข้อกำหนดการดำเนินงาน!',
  SuccessfullyAddedPortRequirements: 'เพิ่มข้อกำหนดท่าเรือสำเร็จ',
  SuccessfullyModifiedPortRequirements: 'แก้ไขข้อกำหนดท่าเรือสำเร็จ',
  MarksAndNumbers: 'เครื่องหมายการขนส่ง',
  IMDGCODEImport: 'นำเข้า IMDG CODE',
  PleaseUploadTxtFormatFile: 'กรุณาอัปโหลดไฟล์รูปแบบ txt!',
  SuccessfullyImported: 'นำเข้าเสร็จสิ้น',
  Items3: 'ข้อมูลรายการ',
  DangerousGoodsList: 'รายการสินค้าอันตราย',
  NoteSystemReminder: 'หมายเหตุ: การแจ้งเตือนเป็นแบบ "ระบบแจ้งเตือน" โดยระบบจะแจ้งเตือนอีกครั้งก่อนครบกำหนด 2 วัน',
  CustomerSignedRenewal: 'ลูกค้ารายนี้ได้ลงนาม{0} แล้ว สามารถเลือกลูกค้านี้เพื่อต่ออายุสัญญาได้!',
  DuplicateBaseCurrencyValueExcel: 'สกุลเงินเดิม ค่า \'{0}\', สกุลเงินฐาน ค่า \'{1}\' ซ้ำกับข้อมูลอื่นใน Excel!',
  DuplicateCurrencyValue0Table: 'สกุลเงินเดิม ค่า \'{0}\', สกุลเงินฐาน ค่า \'{1}\' ซ้ำกับข้อมูลที่มีอยู่ในตารางแล้ว!',
  DoOfThe00: 'ยืนยันการยกเลิกสัญญา \'{1}\' กับ \'{0}\' หรือไม่?',
  UploadPiecesUploadFailedPieces: 'อัปโหลดสำเร็จ: {0} รายการ, อัปโหลดไม่สำเร็จ: {1} รายการ.',
  DoWantToDelete0: 'ยืนยันการลบ【{0}】หรือไม่?',
  TheValueIs0Excel: 'สกุลเงินเดิม ค่า \'{0}\', สกุลเงินฐาน ค่า \'{1}\' ซ้ำกับข้อมูลอื่นใน Excel!',
  TheIs0WhichTable: 'สกุลเงินเดิม ค่า \'{0}\', สกุลเงินฐาน ค่า \'{1}\' ซ้ำกับข้อมูลที่มีอยู่ในตารางแล้ว!',
  ChargeGroup: 'กลุ่มค่าใช้จ่าย',
  DefaultWhtRate: 'อัตราภาษี WHT เริ่มต้น',
  ApplicableWhtTax: 'ใช้ภาษี WHT',
  ApplicableWhtTaxTip: 'ใช้สำหรับฟังก์ชันคืนภาษี WHT (ภาษีหัก ณ ที่จ่าย) ของประเทศไทย จำเป็นต้องตั้งค่าสาขาเพื่อเปิดใช้งานฟังก์ชันนี้',
  ExchangeRateDecimalPlaces: 'ทศนิยมอัตราแลกเปลี่ยน',
  SeaAirRoutes: 'เส้นทางเดินเรือ/เครื่องบิน',
  AppliedSeaport: 'ใช้ท่าเรือทะเล',
  AppliedShippingCompany: 'ใช้บริษัทเรือ',
  ApplicationAirport: 'ใช้ท่าอากาศยาน',
  AppliedAirlines: 'สายการบินที่ใช้งาน',
  VerificationItem: 'รายการตรวจสอบ',
  SensitiveWordExists: 'คลังคำที่ละเอียดอ่อนมีอยู่แล้ว',
  ClearCreditExpiration: 'ล้างการควบคุมเครดิตหลังหมดอายุ',
  SubordinateCompanyPartners: 'พันธมิตรบริษัทในเครือ',
  GpExplainTitle: 'หัวข้อคำอธิบาย GP',
  UncheckArApMate: 'ไม่เข้าร่วมการตรวจสอบความสอดคล้อง AR/AP',
  UncheckArApMateTip: 'เมื่อติ๊กเลือก รายการค่าใช้จ่ายนี้จะไม่เข้าร่วมการตรวจสอบ "ลูกหนี้รวมเจ้าหนี้"',
  ExistCustomerVendorException: 'มีลูกค้าและซัพพลายเออร์ที่มีชื่อและรหัสเดียวกันอยู่แล้ว บันทึกสำเร็จ',
  ExistCustomerCodeExcepiton: 'มีลูกค้าที่มีชื่อและรหัสเดียวกันอยู่แล้ว บันทึกสำเร็จ',
  ExistVendorCodeException: 'มีซัพพลายเออร์ที่มีชื่อและรหัสเดียวกันอยู่แล้ว บันทึกสำเร็จ',
  SyncCustomerCodeExcepiton: 'การซิงค์รหัสลูกค้าผิดปกติ ได้ล้างรหัสลูกค้าแล้ว',
  SyncVendorCodeException: 'การซิงค์รหัสซัพพลายเออร์ผิดปกติ ได้ล้างรหัสซัพพลายเออร์แล้ว',
  mailing: 'รับ-ส่ง-สื่อสาร',
  SyncCustomerVendorException: 'การซิงค์รหัสลูกค้าและซัพพลายเออร์ผิดปกติ ได้ล้างรหัสลูกค้าและซัพพลายเออร์แล้ว',
  b2bWebsiteDisplayNotEmpty: 'การแสดงผลเว็บไซต์ B2B ไม่สามารถเว้นว่างได้',
  IsItManualLaborCost: 'เป็นค่าใช้จ่ายที่ทำมือหรือไม่',
  FreeOfArCharge: 'ยกเว้นการรับ',
  FreeOfApCharge: 'ยกเว้นการจ่าย',
  MergeAndDisplayToDesignatedFees: 'รวมการแสดงผลไปยังค่าใช้จ่ายที่กำหนด',
  MergeAndDisplayTips: 'ในขั้นตอนนี้ ผู้เช่าปัจจุบันรองรับการรวมแสดงผลค่าใช้จ่ายเพียงหนึ่งชุด',
  MergeAndDisplayToDesignatedFeesTips: 'สำหรับโมดูลสอบถามการขายและการจองห้องโดยสารระยะไกล ค่าใช้จ่ายที่ต้องจ่ายจะถูกรวมแสดงผลเป็นชื่อค่าใช้จ่ายที่กำหนด ในขั้นตอนนี้ รองรับการตั้งค่าการรวมแสดงผลค่าใช้จ่ายเพียงหนึ่งชุด',
  operationTip: 'การดำเนินการนี้ไม่สามารถย้อนกลับได้หลังยืนยัน！！！！',
  MscService: 'รหัสบริการ Msc',
  PropulsionType: 'ประเภทการขับเคลื่อน',
  AircraftModel: 'รุ่นเครื่องบิน',
  UnitLoadDevice: 'เครื่องบรรจุ'
}
